import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c064830"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-sm" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "well well-sm" }
const _hoisted_4 = { class: "panel" }
const _hoisted_5 = { style: {"width":"90px","height":"90px","margin-top":"-15px","margin-bottom":"-15px"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Numar ", -1))
const _hoisted_9 = { class: "text__title--medium" }
const _hoisted_10 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row","width":"100%"}
}
const _hoisted_11 = {
  key: 0,
  style: {"margin-left":"auto","display":"flex","position":"relative"}
}
const _hoisted_12 = {
  key: 1,
  style: {"margin-left":"auto","display":"flex","position":"relative"}
}
const _hoisted_13 = {
  key: 2,
  style: {"margin-left":"auto","display":"flex","position":"relative"}
}
const _hoisted_14 = {
  key: 3,
  style: {"margin-left":"auto","display":"flex","position":"relative"}
}
const _hoisted_15 = {
  key: 4,
  style: {"margin-left":"auto","display":"flex","position":"relative"}
}
const _hoisted_16 = {
  key: 5,
  style: {"margin-left":"auto","display":"flex","position":"relative"}
}
const _hoisted_17 = {
  key: 6,
  style: {"margin-left":"auto","display":"flex","position":"relative"}
}
const _hoisted_18 = {
  key: 7,
  style: {"margin-left":"auto","min-height":"90px","display":"flex","position":"relative","top":"-15px","margin-right":"-15px"}
}
const _hoisted_19 = {
  key: 1,
  style: {"display":"flex","justify-content":"flex-end","flex-direction":"row","width":"100%","align-items":"center","margin-right":"10px"}
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text__title--big" }, "Document Arhivat", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "row" }
const _hoisted_23 = {
  class: "col-md-7",
  style: {"padding-right":"5px"}
}
const _hoisted_24 = { class: "table table-nocondensed" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text__title--medium",
  style: {"min-width":"200px"}
}, " Registru: ", -1))
const _hoisted_26 = { class: "text__input--medium bg-white" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "text__title--medium",
  style: {"min-width":"200px"}
}, " Tip inregistrare: ", -1))
const _hoisted_28 = { class: "text__input--medium bg-white" }
const _hoisted_29 = { class: "text__title--medium" }
const _hoisted_30 = { style: {"display":"flex"} }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tip document:", -1))
const _hoisted_32 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto","color":"red"}
}
const _hoisted_33 = {
  key: 0,
  class: "text__input--medium bg-white"
}
const _hoisted_34 = {
  key: 1,
  class: "text__input--medium bg-white"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Numar/Data document: ", -1))
const _hoisted_36 = { class: "text__input--medium bg-white" }
const _hoisted_37 = { class: "text__title--medium" }
const _hoisted_38 = { style: {"display":"flex"} }
const _hoisted_39 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_40 = { class: "text__input--medium bg-white" }
const _hoisted_41 = { class: "text__title--medium" }
const _hoisted_42 = { style: {"display":"flex"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CNP/CUI:", -1))
const _hoisted_44 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_45 = { class: "text__input--medium bg-white" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "text__title--medium" }
const _hoisted_48 = { style: {"display":"flex"} }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Adresa:", -1))
const _hoisted_50 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Editare adresa", -1))
const _hoisted_52 = { class: "q-pa-md" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Tara", -1))
const _hoisted_55 = { class: "row" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Judet", -1))
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Localitate", -1))
const _hoisted_59 = { class: "row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Adresa 1", -1))
const _hoisted_61 = { class: "row" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Adresa 2", -1))
const _hoisted_63 = { class: "row" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Cod postal", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_66 = { class: "absolute-bottom-right q-pa-sm" }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { class: "text__title--medium" }
const _hoisted_69 = { style: {"display":"flex"} }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Reprezentant:", -1))
const _hoisted_71 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_72 = { class: "text__input--medium bg-white" }
const _hoisted_73 = { key: 2 }
const _hoisted_74 = { class: "text__title--medium" }
const _hoisted_75 = { style: {"display":"flex"} }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Telefon:", -1))
const _hoisted_77 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_78 = { class: "text__input--medium bg-white" }
const _hoisted_79 = { key: 3 }
const _hoisted_80 = { class: "text__title--medium" }
const _hoisted_81 = { style: {"display":"flex"} }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Email solicitant:", -1))
const _hoisted_83 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_84 = { class: "text__input--medium bg-white" }
const _hoisted_85 = { class: "text__title--medium" }
const _hoisted_86 = { style: {"display":"flex"} }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Titlu:", -1))
const _hoisted_88 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_89 = { class: "text__input--medium bg-white" }
const _hoisted_90 = { class: "text__title--medium" }
const _hoisted_91 = { style: {"display":"flex"} }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Descriere:", -1))
const _hoisted_93 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_94 = { class: "text__input--medium bg-white" }
const _hoisted_95 = { class: "text__title--medium" }
const _hoisted_96 = { style: {"display":"flex"} }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Numar file:", -1))
const _hoisted_98 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_99 = { class: "text__input--medium bg-white" }
const _hoisted_100 = { key: 4 }
const _hoisted_101 = { class: "text__title--medium" }
const _hoisted_102 = { style: {"display":"flex"} }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Persoana initiator:", -1))
const _hoisted_104 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_105 = { class: "text__input--medium bg-white" }
const _hoisted_106 = { class: "q-pa-xs" }
const _hoisted_107 = { class: "row" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_109 = { class: "absolute-bottom-right q-pa-sm" }
const _hoisted_110 = { key: 5 }
const _hoisted_111 = { class: "text__title--medium" }
const _hoisted_112 = { style: {"display":"flex"} }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OrgUnit initiator:", -1))
const _hoisted_114 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_115 = { class: "text__input--medium bg-white" }
const _hoisted_116 = { class: "q-pa-xs" }
const _hoisted_117 = { class: "row" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_119 = { class: "absolute-bottom-right q-pa-sm" }
const _hoisted_120 = { key: 6 }
const _hoisted_121 = { class: "text__title--medium" }
const _hoisted_122 = { style: {"display":"flex"} }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "OrgUnit destinatar:", -1))
const _hoisted_124 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_125 = { class: "text__input--medium bg-white" }
const _hoisted_126 = { class: "q-pa-xs" }
const _hoisted_127 = { class: "row" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_129 = { class: "absolute-bottom-right q-pa-sm" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Numar document extern: ", -1))
const _hoisted_131 = { class: "text__input--medium bg-white" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, " Stare: ", -1))
const _hoisted_133 = { class: "text__input--medium bg-white" }
const _hoisted_134 = { class: "text__title--medium" }
const _hoisted_135 = { style: {"display":"flex"} }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Referinta:", -1))
const _hoisted_137 = {
  key: 0,
  class: "material-icons",
  style: {"margin-left":"auto"}
}
const _hoisted_138 = { class: "text__input--medium bg-white" }
const _hoisted_139 = { class: "row" }
const _hoisted_140 = { key: 0 }
const _hoisted_141 = { key: 1 }
const _hoisted_142 = {
  key: 2,
  style: {"margin-left":"5px"}
}
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Editare referinta", -1))
const _hoisted_144 = { class: "q-pa-md" }
const _hoisted_145 = { class: "row" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Registru referinta", -1))
const _hoisted_147 = {
  class: "row",
  style: {"margin-top":"10px"}
}
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Numar doc. referinta", -1))
const _hoisted_149 = {
  key: 0,
  class: "col-8"
}
const _hoisted_150 = {
  key: 1,
  class: "col-8",
  style: {"max-width":"220px"}
}
const _hoisted_151 = {
  class: "row",
  style: {"width":"500px"}
}
const _hoisted_152 = { style: {"width":"25%","display":"flex","justify-content":"flex-start"} }
const _hoisted_153 = { style: {"width":"15%","display":"flex","justify-content":"center"} }
const _hoisted_154 = { style: {"width":"60%","display":"flex","justify-content":"flex-end"} }
const _hoisted_155 = { class: "row" }
const _hoisted_156 = { style: {"width":"100%","display":"flex","justify-content":"flex-end"} }
const _hoisted_157 = { class: "row" }
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "col-4 form__label" }, "Data doc. referinta", -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_160 = { class: "absolute-bottom-right q-pa-sm" }
const _hoisted_161 = { class: "text__title--medium" }
const _hoisted_162 = { style: {"display":"flex"} }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Repartizat la:", -1))
const _hoisted_164 = { key: 0 }
const _hoisted_165 = { class: "text__input--medium bg-white" }
const _hoisted_166 = ["onClick"]
const _hoisted_167 = ["onClick"]
const _hoisted_168 = { key: 7 }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Sursa:")
  ])
], -1))
const _hoisted_170 = { class: "text__input--medium bg-white" }
const _hoisted_171 = { key: 8 }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Document anulat de:")
  ])
], -1))
const _hoisted_173 = { class: "text__input--medium bg-white" }
const _hoisted_174 = { key: 9 }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Data anulat: ")
  ])
], -1))
const _hoisted_176 = { class: "text__input--medium bg-white" }
const _hoisted_177 = { key: 10 }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Motivul anulat: ")
  ])
], -1))
const _hoisted_179 = { class: "text__input--medium bg-white" }
const _hoisted_180 = { key: 11 }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text__title--medium" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", null, "Arhivat: ")
  ])
], -1))
const _hoisted_182 = { class: "text__input--medium bg-white" }
const _hoisted_183 = {
  class: "col-md-5",
  style: {"padding-left":"2em","display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"center"}
}
const _hoisted_184 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"100%"} }
const _hoisted_185 = { style: {"display":"flex","flex-direction":"row","align-items":"center","justify-content":"center"} }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__title--medium" }, "Documente")
], -1))
const _hoisted_187 = { key: 0 }
const _hoisted_188 = {
  class: "text__label--thin",
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_189 = { style: {"display":"flex","justify-content":"center","flex-direction":"column"} }
const _hoisted_190 = {
  key: 1,
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"50vh"}
}
const _hoisted_191 = { key: 0 }
const _hoisted_192 = ["onClick"]
const _hoisted_193 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_194 = { class: "mobile-only" }
const _hoisted_195 = { key: 1 }
const _hoisted_196 = { key: 2 }
const _hoisted_197 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_198 = {
  class: "table table-bordered table-condensed table-responsive",
  style: {"width":"100%","max-height":"5vh"}
}
const _hoisted_199 = {
  class: "desktop-only",
  style: {"max-width":"30vw"}
}
const _hoisted_200 = { class: "mobile-only" }
const _hoisted_201 = { style: {"margin-left":"40%","margin-right":"40%","margin-top":"10px","margin-bottom":"10px","min-width":"100px","max-height":"50vh"} }
const _hoisted_202 = {
  key: 0,
  style: {"width":"100%","display":"flex","justify-content":"flex-end"}
}
const _hoisted_203 = {
  key: 1,
  clas: "row",
  style: {"margin-top":"5px","margin-bottom":"15px"}
}
const _hoisted_204 = { key: 2 }
const _hoisted_205 = { class: "row" }
const _hoisted_206 = { style: {"margin-left":"5px"} }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_208 = { class: "column" }
const _hoisted_209 = { class: "row" }
const _hoisted_210 = ["onClick"]
const _hoisted_211 = { class: "row" }
const _hoisted_212 = ["onClick"]
const _hoisted_213 = {
  key: 0,
  style: {"margin-top":"10px","width":"100%","display":"flex","justify-content":"flex-end"}
}
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "div_btn_repartizeaza",
  style: {"margin-top":"10px"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_215 = { key: 3 }
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-weight-bold" }, "Incarca fisier nou", -1))
const _hoisted_217 = {
  class: "text-grey",
  style: {"margin-top":"4px","margin-bottom":"10px"}
}
const _hoisted_218 = {
  key: 0,
  class: "q-pa-md flex flex-center",
  style: {"background-color":"#ececec"}
}
const _hoisted_219 = { key: 1 }
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--big",
  style: {"color":"black"}
}, "Org Unit", -1))
const _hoisted_221 = { class: "q-pa-md" }
const _hoisted_222 = { style: {"width":"100%"} }
const _hoisted_223 = { class: "row" }
const _hoisted_224 = { key: 0 }
const _hoisted_225 = { key: 1 }
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_227 = { style: {"padding-bottom":"20px"} }
const _hoisted_228 = { style: {"float":"right"} }
const _hoisted_229 = {
  key: 0,
  class: "q-pa-md flex flex-center",
  style: {"background-color":"#ececec"}
}
const _hoisted_230 = { key: 1 }
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text__title--big",
  style: {"color":"black"}
}, "Utilizator", -1))
const _hoisted_232 = { class: "q-pa-md" }
const _hoisted_233 = { style: {"width":"100%"} }
const _hoisted_234 = { class: "row" }
const _hoisted_235 = {
  class: "row",
  style: {"width":"150px","margin-top":"5px","margin-bottom":"5px","display":"flex","justify-content":"flex-start"}
}
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-family":"'PT Sans Narrow', sans-serif","font-size":"0.9em"} }, "Arata si cele inactive", -1))
const _hoisted_237 = { key: 0 }
const _hoisted_238 = { key: 1 }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_240 = { style: {"padding-bottom":"20px"} }
const _hoisted_241 = { style: {"float":"right"} }
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Istoric repartizari", -1))
const _hoisted_243 = {
  key: 0,
  class: "q-pa-md flex flex-center",
  style: {"background-color":"#ececec"}
}
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Mesaje", -1))
const _hoisted_245 = { class: "q-pa-md row justify-center" }
const _hoisted_246 = { style: {"width":"100%"} }
const _hoisted_247 = { key: 0 }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center"} }, " Nu exista mesaje... ", -1))
const _hoisted_249 = [
  _hoisted_248
]
const _hoisted_250 = { style: {"white-space":"pre-line"} }
const _hoisted_251 = {
  class: "q-pa-sm row",
  style: {"width":"100%"}
}
const _hoisted_252 = {
  class: "col-10",
  style: {"display":"flex","justify-content":"flex-start"}
}
const _hoisted_253 = {
  class: "col-2",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_254 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text__title--medium" }, "Va rugam sa introduceti un motiv", -1))
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare certificate urbanism", -1))
const _hoisted_256 = {
  key: 1,
  id: "iframe_preview_scan",
  type: "application/pdf",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none"}
}
const _hoisted_257 = {
  key: 2,
  id: "iframe_preview_scan",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none","display":"block"}
}
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cursor-pointer" }, "Formular editare servicii de transport", -1))
const _hoisted_259 = {
  key: 1,
  id: "iframe_preview_scan",
  type: "application/pdf",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none"}
}
const _hoisted_260 = {
  key: 2,
  id: "iframe_preview_scan",
  width: "100%",
  height: "100%",
  style: {"width":"100%","height":"calc(100vh - 70px)","overflow":"auto","border":"none","display":"block"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_ExpeditiiDocument = _resolveComponent("ExpeditiiDocument")!
  const _component_ChangeTipDocument = _resolveComponent("ChangeTipDocument")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_popup_edit = _resolveComponent("q-popup-edit")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_DialogOpenScan = _resolveComponent("DialogOpenScan")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_TaskList = _resolveComponent("TaskList")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_RepartizatHistoric = _resolveComponent("RepartizatHistoric")!
  const _component_q_chat_message = _resolveComponent("q-chat-message")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_EditCertificateUrbanism = _resolveComponent("EditCertificateUrbanism")!
  const _component_EditServiciiDeTransport = _resolveComponent("EditServiciiDeTransport")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loadingDocumentData)
      ? (_openBlock(), _createBlock(_component_q_spinner_gears, {
          key: 0,
          color: "primary",
          size: "4em",
          class: "absolute-center"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "panel-body",
                style: _normalizeStyle(_ctx.docApp.status == 'archived' ? 'display:flex; align-items:center; height: 100px;' : 'display:flex; align-items:center;')
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", { src: _ctx.qrCode }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: _normalizeClass({ 'column': _ctx.$q.platform.is.mobile, 'row': _ctx.$q.platform.is.desktop })
                  }, [
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.docApp.id_doc) + " / " + _toDisplayString(_ctx.displayDataLong(_ctx.docApp.track_creation_date)), 1)
                  ], 2),
                  _createVNode(_component_q_btn, {
                    color: "white",
                    "text-color": "black",
                    "icon-right": "print",
                    label: "Tipareste!",
                    disable: _ctx.loadingPdfForDownload,
                    "no-caps": "",
                    loading: _ctx.loadingPdfForDownload,
                    onClick: _ctx.prepareCoverPdfForDownload
                  }, {
                    loading: _withCtx(() => [
                      _createVNode(_component_q_spinner_gears, { class: "on-right" }),
                      _createTextVNode(" Pregatire... ")
                    ]),
                    _: 1
                  }, 8, ["disable", "loading", "onClick"])
                ]),
                (!['archived', 'cancellation'].includes(_ctx.docApp.status))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (['APP_DEV', 'APP_CV', 'APP_CJCV', 'APP_HR'].includes(_ctx.APP_NAME) && _ctx.docApp.tip_request === 'intrare' && _ctx.docApp.sursa === 'Portal')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_q_btn, {
                              flat: "",
                              outline: "",
                              dense: "",
                              label: "Mesaje",
                              "icon-right": "mail_outline",
                              color: "primary",
                              class: "q-ml-sm",
                              onClick: _ctx.onOpenMessage
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.docApp.tip_request === 'intrare' && _ctx.docApp.finalizat_de_inregistrat == 'y')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_q_btn, {
                              flat: "",
                              outline: "",
                              dense: "",
                              label: "Creaza document iesire",
                              "icon-right": "output",
                              color: "primary",
                              class: "q-ml-sm",
                              onClick: _ctx.onCreateDocumentIesire
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.accesFrom === 'certificateurbanism') && ((Number(_ctx.docApp.tip_doc_flag) & 2) != 0) && _ctx.docApp.appid_document_extended == null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_q_btn, {
                              flat: "",
                              outline: "",
                              dense: "",
                              label: "Genereaza Certificat",
                              "icon-right": "output",
                              color: "primary",
                              class: "q-ml-sm",
                              onClick: _ctx.onGenerateDocument
                            }, null, 8, ["onClick"])
                          ]))
                        : ((_ctx.accesFrom === 'serviciidetransport') && ((Number(_ctx.docApp.tip_doc_flag) & 4) != 0) && _ctx.docApp.appid_document_extended == null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_q_btn, {
                                flat: "",
                                outline: "",
                                dense: "",
                                label: "Genereaza AST",
                                "icon-right": "output",
                                color: "primary",
                                class: "q-ml-sm",
                                onClick: _ctx.onGenerateDocument
                              }, null, 8, ["onClick"])
                            ]))
                          : ((_ctx.accesFrom === 'certificateurbanism') && ((Number(_ctx.docApp.tip_doc_flag) & 2) != 0) && _ctx.docApp.appid_document_extended != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createVNode(_component_q_btn, {
                                  flat: "",
                                  outline: "",
                                  dense: "",
                                  label: "Vizualizeaza Certificat",
                                  "icon-right": "output",
                                  color: "primary",
                                  class: "q-ml-sm",
                                  onClick: _ctx.onViewDocument
                                }, null, 8, ["onClick"])
                              ]))
                            : ((_ctx.accesFrom === 'serviciidetransport') && ((Number(_ctx.docApp.tip_doc_flag) & 4) != 0) && _ctx.docApp.appid_document_extended != null)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createVNode(_component_q_btn, {
                                    flat: "",
                                    outline: "",
                                    dense: "",
                                    label: "Vizualizeaza AST",
                                    "icon-right": "output",
                                    color: "primary",
                                    class: "q-ml-sm",
                                    onClick: _ctx.onViewDocument
                                  }, null, 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true),
                      (_ctx.user.is_admin=='y' && (Number(_ctx.docApp.flag) & 1) == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_q_btn, {
                              flat: "",
                              outline: "",
                              dense: "",
                              label: "Anuleaza document",
                              "icon-right": "output",
                              color: "deep-orange",
                              class: "q-ml-sm",
                              onClick: _ctx.onCancellationDocument
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true),
                      (!['certificateurbanism', 'serviciidetransport'].includes(_ctx.accesFrom))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_ExpeditiiDocument, {
                              appid: _ctx.appid,
                              isAllowOperator: (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.user.auth_for_expeditie === 'y'
                            }, null, 8, ["appid", "isAllowOperator"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.docApp.status == 'archived')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                    : _createCommentVNode("", true)
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("table", _hoisted_24, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_25,
                      _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.displayDenumireRegistru(_ctx.docApp.id_registru)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_27,
                      _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.docApp.tip_request), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval')))))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, "create"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval')))))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                            _createVNode(_component_q_btn, {
                              flat: "",
                              outline: "",
                              dense: "",
                              style: {"padding":"0px"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.getDenTipDocument(_ctx.docApp.id_tip_document as number)) + " ", 1),
                                _createVNode(_component_q_popup_proxy, { ref: "changeTipDocProxy" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ChangeTipDocument, {
                                      appid: _ctx.appid,
                                      prop_id_registru: _ctx.docApp.id_registru,
                                      prop_id_categ: _ctx.docApp.id_categ,
                                      prop_id_tip_doc: _ctx.docApp.id_tip_document,
                                      fRenuntModificareTipDoc: _ctx.fRenuntModificareTipDoc,
                                      fModificareTipDoc: _ctx.fModificareTipDoc
                                    }, null, 8, ["appid", "prop_id_registru", "prop_id_categ", "prop_id_tip_doc", "fRenuntModificareTipDoc", "fModificareTipDoc"])
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(_ctx.getDenTipDocument(_ctx.docApp.id_tip_document as number)), 1))
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_35,
                      _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.docApp.id_doc) + " / " + _toDisplayString(_ctx.displayDataLong(_ctx.docApp.data_doc)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.docApp.tip_solicitant === 'pf' ? 'Nume prenume:' : ['APP_MAGIC'].includes(_ctx.APP_NAME) ? 'Denumire' : _ctx.docApp.tip_request == 'intern' ? 'Denumire destinatar' : 'Denumire solicitant:'), 1),
                          ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, "create"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_40, [
                        _createTextVNode(_toDisplayString(_ctx.docApp.nume_denumire) + " ", 1),
                        ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                          ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                              key: 0,
                              modelValue: _ctx.docApp.nume_denumire,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.docApp.nume_denumire) = $event)),
                              validate: val => val.length > 3,
                              style: _normalizeStyle(_ctx.docApp.tip_request == 'intern' ? 'width:500px;' : '')
                            }, _createSlots({ _: 2 }, [
                              (_ctx.docApp.tip_request != 'intern' || (_ctx.docApp.tip_request == 'intern' && _ctx.docApp.tip_solicitant == 'pf'))
                                ? {
                                    name: "default",
                                    fn: _withCtx((scope) => [
                                      _createVNode(_component_q_input, {
                                        autofocus: "",
                                        dense: "",
                                        modelValue: scope.value,
                                        "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                        style: {"min-width":"300px"},
                                        value: _ctx.docApp.nume_denumire,
                                        hint: "Modificare nume / denumire",
                                        rules: [val => scope.validate(scope.value) || 'Minim 3 caractere']
                                      }, {
                                        after: _withCtx(() => [
                                          _createVNode(_component_q_btn, {
                                            flat: "",
                                            dense: "",
                                            color: "negative",
                                            icon: "cancel",
                                            onClick: _withModifiers(scope.cancel, ["stop"])
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_q_btn, {
                                            flat: "",
                                            dense: "",
                                            color: "positive",
                                            icon: "check_circle",
                                            onClick: _withModifiers(($event: any) => (_ctx.tryUpdateNumeDenumire(scope)), ["stop"]),
                                            disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                          }, null, 8, ["onClick", "disable"])
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                                    ]),
                                    key: "0"
                                  }
                                : {
                                    name: "default",
                                    fn: _withCtx((scope) => [
                                      _createElementVNode("div", { class: "q-pa-xs" }, [
                                        _createElementVNode("div", { class: "row" }, [
                                          _createVNode(_component_q_select, {
                                            outlined: "",
                                            "lazy-rules": "",
                                            "model-value": _ctx.nume_denumire,
                                            "use-input": "",
                                            "hide-selected": "",
                                            "fill-input": "",
                                            "input-debounce": "300",
                                            options: _ctx.optionsOrgUnitPopup,
                                            onFilter: _ctx.filterOrgUnit,
                                            onNewValue: _cache[0] || (_cache[0] = (value) => _ctx.setOrgUnitModel(value, 'nume_denumire')),
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => _ctx.setOrgUnitModel(value, 'nume_denumire')),
                                            "emit-value": "",
                                            clearable: "",
                                            style: {"max-height":"7vh","width":"500px"},
                                            dense: "",
                                            "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                                            rules: [ val => val && val.length > 0 || ('Completati numele / denumirea destinatarului')],
                                            "option-value": "organization_unit_descriere",
                                            "option-label": "organization_unit_descriere"
                                          }, null, 8, ["model-value", "options", "onFilter", "rules"])
                                        ]),
                                        _createElementVNode("br"),
                                        _createElementVNode("div", { class: "absolute-bottom-right q-pa-sm" }, [
                                          _createVNode(_component_q_btn, {
                                            label: "Salveaza",
                                            size: "sm",
                                            color: "primary",
                                            onClick: ($event: any) => (_ctx.onSaveDocumentDenumireDestinatar(scope))
                                          }, null, 8, ["onClick"]),
                                          _createVNode(_component_q_btn, {
                                            label: "Renunt",
                                            size: "sm",
                                            type: "reset",
                                            flat: "",
                                            onClick: ($event: any) => (_ctx.onCancelDocumentDenumireDestinatar(scope)),
                                            style: {"margin-left":"5px"}
                                          }, null, 8, ["onClick"])
                                        ])
                                      ])
                                    ]),
                                    key: "1"
                                  }
                            ]), 1032, ["modelValue", "validate", "style"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, "create"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_45, [
                        _createTextVNode(_toDisplayString(_ctx.docApp.cui) + " ", 1),
                        ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                          ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                              key: 0,
                              modelValue: _ctx.docApp.cui,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.docApp.cui) = $event)),
                              validate: val => _ctx.validateCNPORCIF(val||'')
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_q_input, {
                                  autofocus: "",
                                  dense: "",
                                  modelValue: scope.value,
                                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                  style: {"min-width":"300px"},
                                  value: _ctx.docApp.cui,
                                  hint: "Modificare cod identificare fiscala",
                                  rules: 
                                                        _ctx.docApp.tip_solicitant === 'pf' ? //persoana fizica
                                                            [                                                      
                                                                (val) => !val || (val.length > 0 && _ctx.validateCNP(scope.value||'')) || 'CNP invalid!'
                                                            ] : 
                                                            [                                
                                                                (val) => !val || (val.length > 0 && _ctx.validateRomanianCIF(scope.value||'')) || 'CUI invalid!'
                                                            ]
                                }, {
                                  after: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "negative",
                                      icon: "cancel",
                                      onClick: _withModifiers(scope.cancel, ["stop"])
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "positive",
                                      icon: "check_circle",
                                      onClick: _withModifiers(($event: any) => (_ctx.tryUpdateCui(scope)), ["stop"]),
                                      disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                    }, null, 8, ["onClick", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "validate"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    ((_ctx.docApp.tip_request=='intrare' || _ctx.docApp.tip_request=='iesire'))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                          _createElementVNode("td", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _hoisted_49,
                              ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_50, "create"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", {
                            class: "text__input--medium bg-white",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.visibleDialogEditAdresa = (_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || ((_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y')))))
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.docApp.adresa) + " ", 1),
                            _createVNode(_component_q_dialog, {
                              modelValue: _ctx.visibleDialogEditAdresa,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visibleDialogEditAdresa) = $event)),
                              persistent: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"80vw"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_bar, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, { name: "add_box" }),
                                        _hoisted_51,
                                        _createVNode(_component_q_space),
                                        _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                                          dense: "",
                                          flat: "",
                                          icon: "close"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_tooltip, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode("Close")
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })), [
                                          [_directive_close_popup]
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_q_card_section, null, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_52, [
                                          _createVNode(_component_q_form, { ref: "myForm" }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_53, [
                                                _hoisted_54,
                                                _createVNode(_component_q_select, {
                                                  outlined: "",
                                                  modelValue: _ctx.docApp.id_tara,
                                                  "onUpdate:modelValue": [
                                                    _cache[4] || (_cache[4] = ($event: any) => ((_ctx.docApp.id_tara) = $event)),
                                                    _ctx.onValueChangeTara
                                                  ],
                                                  options: _ctx.optionsTari,
                                                  "option-value": "appid",
                                                  "option-label": "denumire",
                                                  "emit-value": "",
                                                  "map-options": "",
                                                  "lazy-rules": "",
                                                  class: "col-8",
                                                  style: {"max-height":"7vh"},
                                                  dense: "",
                                                  "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                                                  rules: [ val => val && val > 0 || 'Alegeti tara!']
                                                }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "rules"])
                                              ]),
                                              _createElementVNode("div", _hoisted_55, [
                                                _hoisted_56,
                                                _createVNode(_component_q_select, {
                                                  outlined: "",
                                                  modelValue: _ctx.docApp.id_judet,
                                                  "onUpdate:modelValue": [
                                                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.docApp.id_judet) = $event)),
                                                    _ctx.onValueChangeJudet
                                                  ],
                                                  options: _ctx.optionsJudete,
                                                  "option-value": "appid",
                                                  "option-label": "denumire",
                                                  "emit-value": "",
                                                  "map-options": "",
                                                  "lazy-rules": "",
                                                  "use-input": "",
                                                  "input-debounce": "300",
                                                  onFilter: _ctx.filterJudet,
                                                  class: "col-8",
                                                  style: {"max-height":"7vh"},
                                                  dense: "",
                                                  "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                                                  rules: [ val => val && val > 0 || 'Alegeti judetul!']
                                                }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "onFilter", "rules"])
                                              ]),
                                              _createElementVNode("div", _hoisted_57, [
                                                _hoisted_58,
                                                _createVNode(_component_q_select, {
                                                  outlined: "",
                                                  modelValue: _ctx.docApp.id_localitate,
                                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.docApp.id_localitate) = $event)),
                                                  options: _ctx.optionsLocalitati,
                                                  "option-value": "appid",
                                                  "option-label": "denumire",
                                                  "emit-value": "",
                                                  "map-options": "",
                                                  "lazy-rules": "",
                                                  "use-input": "",
                                                  "input-debounce": "300",
                                                  onFilter: _ctx.filterLocalitate,
                                                  class: "col-8",
                                                  style: {"max-height":"7vh"},
                                                  dense: "",
                                                  "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                                                  rules: [ val => val && val > 0 || 'Alegeti localitate!']
                                                }, null, 8, ["modelValue", "options", "onFilter", "rules"])
                                              ]),
                                              _createElementVNode("div", _hoisted_59, [
                                                _hoisted_60,
                                                _createVNode(_component_q_select, {
                                                  outlined: "",
                                                  "lazy-rules": "",
                                                  "model-value": _ctx.docApp.strada,
                                                  "use-input": "",
                                                  "hide-selected": "",
                                                  "fill-input": "",
                                                  "input-debounce": "300",
                                                  options: _ctx.optionsAdrese,
                                                  onFilter: _ctx.filterAdresa,
                                                  onNewValue: _ctx.setAdresaModel,
                                                  "onUpdate:modelValue": _ctx.setAdresaModel,
                                                  onBlur: _ctx.onBlurAdresa,
                                                  onPopupShow: _ctx.onShowPopup,
                                                  "emit-value": "",
                                                  clearable: "",
                                                  class: "col-8",
                                                  style: {"max-height":"7vh"},
                                                  dense: "",
                                                  label: "Denumire strada",
                                                  "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                                                  "option-value": "strada",
                                                  "option-label": "strada"
                                                }, null, 8, ["model-value", "options", "onFilter", "onNewValue", "onUpdate:modelValue", "onBlur", "onPopupShow"])
                                              ]),
                                              _createElementVNode("div", _hoisted_61, [
                                                _hoisted_62,
                                                _createVNode(_component_q_input, {
                                                  outlined: "",
                                                  modelValue: _ctx.docApp.numar,
                                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.docApp.numar) = $event)),
                                                  "lazy-rules": "",
                                                  class: "col-8",
                                                  style: {"max-height":"7vh","margin-top":"10px"},
                                                  dense: "",
                                                  label: "Numar strada, cladire, nr apartament / locuinta, alte detalii adresa",
                                                  "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' }
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _createElementVNode("div", _hoisted_63, [
                                                _hoisted_64,
                                                _createVNode(_component_q_input, {
                                                  outlined: "",
                                                  modelValue: _ctx.docApp.cod_postal,
                                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.docApp.cod_postal) = $event)),
                                                  class: "col-8",
                                                  style: {"max-height":"7vh","margin-top":"10px","margin-bottom":"10px"},
                                                  dense: "",
                                                  "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' }
                                                }, null, 8, ["modelValue"])
                                              ])
                                            ]),
                                            _: 1
                                          }, 512),
                                          _hoisted_65,
                                          _createElementVNode("div", _hoisted_66, [
                                            _createVNode(_component_q_btn, {
                                              label: "Salveaza",
                                              size: "sm",
                                              type: "submit",
                                              color: "primary",
                                              onClick: _ctx.onSaveAdresa
                                            }, null, 8, ["onClick"]),
                                            _createVNode(_component_q_btn, {
                                              label: "Renunt",
                                              size: "sm",
                                              type: "reset",
                                              flat: "",
                                              onClick: _ctx.onCancelAdresa,
                                              style: {"margin-left":"5px"}
                                            }, null, 8, ["onClick"])
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.docApp.tip_request=='intrare' || _ctx.docApp.tip_request=='iesire'))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_67, [
                          _createElementVNode("td", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              _hoisted_70,
                              ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_71, "create"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_72, [
                            _createTextVNode(_toDisplayString(_ctx.docApp.nume_prenume_reprezentant) + " ", 1),
                            ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                              ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                                  key: 0,
                                  modelValue: _ctx.docApp.nume_prenume_reprezentant,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.docApp.nume_prenume_reprezentant) = $event))
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode(_component_q_input, {
                                      autofocus: "",
                                      dense: "",
                                      modelValue: scope.value,
                                      "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                      style: {"min-width":"300px"},
                                      value: _ctx.docApp.nume_prenume_reprezentant,
                                      hint: "Modificare nume prenume"
                                    }, {
                                      after: _withCtx(() => [
                                        _createVNode(_component_q_btn, {
                                          flat: "",
                                          dense: "",
                                          color: "negative",
                                          icon: "cancel",
                                          onClick: _withModifiers(scope.cancel, ["stop"])
                                        }, null, 8, ["onClick"]),
                                        _createVNode(_component_q_btn, {
                                          flat: "",
                                          dense: "",
                                          color: "positive",
                                          icon: "check_circle",
                                          onClick: _withModifiers(($event: any) => (_ctx.tryUpdateNumePrenumeReprezentant(scope)), ["stop"]),
                                          disable: scope.initialValue === scope.value
                                        }, null, 8, ["onClick", "disable"])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "value"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.docApp.tip_request=='intrare' || _ctx.docApp.tip_request=='iesire'))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_73, [
                          _createElementVNode("td", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _hoisted_76,
                              ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_77, "create"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_78, [
                            _createTextVNode(_toDisplayString(_ctx.docApp.nr_telefon_reprezentant) + " ", 1),
                            ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                              ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                                  key: 0,
                                  modelValue: _ctx.docApp.nr_telefon_reprezentant,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.docApp.nr_telefon_reprezentant) = $event)),
                                  validate: val => (!val || val > 0)
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode(_component_q_input, {
                                      autofocus: "",
                                      dense: "",
                                      modelValue: scope.value,
                                      "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                      maxlength: "100",
                                      type: "number",
                                      style: {"min-width":"300px"},
                                      value: _ctx.docApp.nr_telefon_reprezentant,
                                      hint: "Modificare numar telefon",
                                      rules: [val => (!val || scope.validate(val)) || 'Nr telefon trebuie sa fie numar pozitive!']
                                    }, {
                                      after: _withCtx(() => [
                                        _createVNode(_component_q_btn, {
                                          flat: "",
                                          dense: "",
                                          color: "negative",
                                          icon: "cancel",
                                          onClick: _withModifiers(scope.cancel, ["stop"])
                                        }, null, 8, ["onClick"]),
                                        _createVNode(_component_q_btn, {
                                          flat: "",
                                          dense: "",
                                          color: "positive",
                                          icon: "check_circle",
                                          onClick: _withModifiers(($event: any) => (_ctx.tryUpdateNrTelefonReprezentant(scope)), ["stop"]),
                                          disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                        }, null, 8, ["onClick", "disable"])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "validate"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.docApp.tip_request=='intrare' || _ctx.docApp.tip_request=='iesire')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_79, [
                          _createElementVNode("td", _hoisted_80, [
                            _createElementVNode("div", _hoisted_81, [
                              _hoisted_82,
                              ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_83, "create"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_84, [
                            _createTextVNode(_toDisplayString(_ctx.docApp.email_solicitant) + " ", 1),
                            ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                              ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                                  key: 0,
                                  modelValue: _ctx.docApp.email_solicitant,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.docApp.email_solicitant) = $event)),
                                  validate: val => _ctx.validateEmail(val)
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode(_component_q_input, {
                                      autofocus: "",
                                      dense: "",
                                      modelValue: scope.value,
                                      "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                      type: "email",
                                      style: {"min-width":"300px"},
                                      value: _ctx.docApp.email_solicitant,
                                      hint: "Modificare adresa email",
                                      rules: [val => (scope.validate(scope.value)) || 'Adresa de email este incorect!']
                                    }, {
                                      after: _withCtx(() => [
                                        _createVNode(_component_q_btn, {
                                          flat: "",
                                          dense: "",
                                          color: "negative",
                                          icon: "cancel",
                                          onClick: _withModifiers(scope.cancel, ["stop"])
                                        }, null, 8, ["onClick"]),
                                        _createVNode(_component_q_btn, {
                                          flat: "",
                                          dense: "",
                                          color: "positive",
                                          icon: "check_circle",
                                          onClick: _withModifiers(($event: any) => (_ctx.tryUpdateEmail(scope)), ["stop"]),
                                          disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                        }, null, 8, ["onClick", "disable"])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "validate"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                          _hoisted_87,
                          ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_88, "create"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_89, [
                        _createTextVNode(_toDisplayString(_ctx.docApp.titlu) + " ", 1),
                        ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                          ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                              key: 0,
                              modelValue: _ctx.docApp.titlu,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.docApp.titlu) = $event)),
                              validate: val => val.length > 3 && val.length <= 100
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_q_input, {
                                  autofocus: "",
                                  dense: "",
                                  modelValue: scope.value,
                                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                  style: {"min-width":"400px"},
                                  value: _ctx.docApp.titlu,
                                  hint: "Modificare titlu",
                                  rules: [val => scope.validate(scope.value) || 'Intre 3 si 100 de carcatere']
                                }, {
                                  after: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "negative",
                                      icon: "cancel",
                                      onClick: _withModifiers(scope.cancel, ["stop"])
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "positive",
                                      icon: "check_circle",
                                      onClick: _withModifiers(($event: any) => (_ctx.tryUpdateTitlu(scope)), ["stop"]),
                                      disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                    }, null, 8, ["onClick", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "validate"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, [
                          _hoisted_92,
                          ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_93, "create"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_94, [
                        _createTextVNode(_toDisplayString(_ctx.docApp.descriere) + " ", 1),
                        ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                          ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                              key: 0,
                              modelValue: _ctx.docApp.descriere,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.docApp.descriere) = $event)),
                              validate: val => val.length > 3 && val.length <= 800
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_q_input, {
                                  autofocus: "",
                                  dense: "",
                                  modelValue: scope.value,
                                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                  type: "textarea",
                                  value: _ctx.docApp.descriere,
                                  style: {"min-width":"400px"},
                                  hint: "Modificare descriere",
                                  rules: [val => scope.validate(scope.value) || 'Intre 3 si 800 de caractere']
                                }, {
                                  after: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "negative",
                                      icon: "cancel",
                                      onClick: _withModifiers(scope.cancel, ["stop"])
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "positive",
                                      icon: "check_circle",
                                      onClick: _withModifiers(($event: any) => (_ctx.tryUpdateDescriere(scope)), ["stop"]),
                                      disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                    }, null, 8, ["onClick", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "validate"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _hoisted_97,
                          ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_98, "create"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_99, [
                        _createTextVNode(_toDisplayString(_ctx.docApp.nr_file) + " ", 1),
                        ((_ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                          ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                              key: 0,
                              modelValue: _ctx.docApp.nr_file,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.docApp.nr_file) = $event)),
                              validate: val => (!val || val > 0)
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_q_input, {
                                  autofocus: "",
                                  dense: "",
                                  modelValue: scope.value,
                                  "onUpdate:modelValue": ($event: any) => ((scope.value) = $event),
                                  type: "number",
                                  value: _ctx.docApp.nr_file,
                                  style: {"min-width":"200px"},
                                  hint: "Modificare nr.file",
                                  rules: [val => (!val || scope.validate(val)) || 'Nr. file trebuie sa fie numar pozitive!']
                                }, {
                                  after: _withCtx(() => [
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "negative",
                                      icon: "cancel",
                                      onClick: _withModifiers(scope.cancel, ["stop"])
                                    }, null, 8, ["onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      color: "positive",
                                      icon: "check_circle",
                                      onClick: _withModifiers(($event: any) => (_ctx.tryUpdateNrFile(scope)), ["stop"]),
                                      disable: scope.validate(scope.value) === false || scope.initialValue === scope.value
                                    }, null, 8, ["onClick", "disable"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "value", "rules"])
                              ]),
                              _: 1
                            }, 8, ["modelValue", "validate"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.docApp.tip_request=='intern' || _ctx.docApp.tip_request=='iesire')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_100, [
                          _createElementVNode("td", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, [
                              _hoisted_103,
                              ((_ctx.docApp.tip_request=='intern' && _ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_104, "create"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_105, [
                            _createTextVNode(_toDisplayString(_ctx.denPersoanaUtilizatorFromMarca(Number(_ctx.docApp.marca_user_deponent))) + " ", 1),
                            ((_ctx.docApp.tip_request=='intern' && _ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                              ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                                  key: 0,
                                  modelValue: _ctx.den_user_deponent,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.den_user_deponent) = $event)),
                                  validate: val => val.length > 0,
                                  style: _normalizeStyle(_ctx.docApp.tip_request == 'intern' ? 'width:500px;' : '')
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("div", _hoisted_106, [
                                      _createElementVNode("div", _hoisted_107, [
                                        _createVNode(_component_q_select, {
                                          outlined: "",
                                          "lazy-rules": "",
                                          "model-value": _ctx.den_user_deponent,
                                          "use-input": "",
                                          "hide-selected": "",
                                          "fill-input": "",
                                          "input-debounce": "300",
                                          options: _ctx.optionsMarcaPopup,
                                          onFilter: _ctx.filterPersoana,
                                          onNewValue: _ctx.setMarcaModel,
                                          "onUpdate:modelValue": _ctx.setMarcaModel,
                                          "emit-value": "",
                                          clearable: "",
                                          style: {"max-height":"7vh","width":"500px"},
                                          dense: "",
                                          "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                                          rules: [ val => val && val.length > 0 || 'Completati nume initiator'],
                                          "option-value": "marca",
                                          "option-label": "nume_prenume"
                                        }, null, 8, ["model-value", "options", "onFilter", "onNewValue", "onUpdate:modelValue", "rules"])
                                      ]),
                                      _hoisted_108,
                                      _createElementVNode("div", _hoisted_109, [
                                        _createVNode(_component_q_btn, {
                                          label: "Salveaza",
                                          size: "sm",
                                          color: "primary",
                                          onClick: ($event: any) => (_ctx.onSaveDocumentMarcaInitiator(scope))
                                        }, null, 8, ["onClick"]),
                                        _createVNode(_component_q_btn, {
                                          label: "Renunt",
                                          size: "sm",
                                          type: "reset",
                                          flat: "",
                                          onClick: ($event: any) => (_ctx.onCancelDocumentMarcaInitiator(scope)),
                                          style: {"margin-left":"5px"}
                                        }, null, 8, ["onClick"])
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "validate", "style"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.docApp.tip_request=='iesire' || _ctx.docApp.tip_request=='intern')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_110, [
                          _createElementVNode("td", _hoisted_111, [
                            _createElementVNode("div", _hoisted_112, [
                              _hoisted_113,
                              ((_ctx.docApp.tip_request=='intern' && _ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_114, "create"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_115, [
                            _createTextVNode(_toDisplayString(_ctx.denOrgUnitFromOrg(Number(_ctx.docApp.id_org_expeditor))) + " ", 1),
                            ((_ctx.docApp.tip_request=='intern' && _ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                              ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                                  key: 0,
                                  modelValue: _ctx.den_org_initiator,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.den_org_initiator) = $event)),
                                  validate: val => val.length > 0,
                                  style: _normalizeStyle(_ctx.docApp.tip_request == 'intern' ? 'width:500px;' : '')
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("div", _hoisted_116, [
                                      _createElementVNode("div", _hoisted_117, [
                                        _createVNode(_component_q_select, {
                                          outlined: "",
                                          "lazy-rules": "",
                                          "model-value": _ctx.den_org_initiator,
                                          "use-input": "",
                                          "hide-selected": "",
                                          "fill-input": "",
                                          "input-debounce": "300",
                                          options: _ctx.optionsOrgUnitPopup,
                                          onFilter: _ctx.filterOrgUnit,
                                          onNewValue: _cache[18] || (_cache[18] = (value) => _ctx.setOrgUnitModel(value, 'id_org_initiator')),
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = (value) => _ctx.setOrgUnitModel(value, 'id_org_initiator')),
                                          "emit-value": "",
                                          clearable: "",
                                          style: {"max-height":"7vh","width":"500px"},
                                          dense: "",
                                          "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                                          rules: [ val => val && val.length > 0 || 'Completati departamentul initiator'],
                                          "option-value": "id",
                                          "option-label": "organization_unit_descriere"
                                        }, null, 8, ["model-value", "options", "onFilter", "rules"])
                                      ]),
                                      _hoisted_118,
                                      _createElementVNode("div", _hoisted_119, [
                                        _createVNode(_component_q_btn, {
                                          label: "Salveaza",
                                          size: "sm",
                                          color: "primary",
                                          onClick: ($event: any) => (_ctx.onSaveDocumentOrgUnitInitiator(scope))
                                        }, null, 8, ["onClick"]),
                                        _createVNode(_component_q_btn, {
                                          label: "Renunt",
                                          size: "sm",
                                          type: "reset",
                                          flat: "",
                                          onClick: ($event: any) => (_ctx.onCancelDocumentOrgUnitInitiator(scope)),
                                          style: {"margin-left":"5px"}
                                        }, null, 8, ["onClick"])
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "validate", "style"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ((_ctx.docApp.tip_request=='intrare' || _ctx.docApp.tip_request=='intern'))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_120, [
                          _createElementVNode("td", _hoisted_121, [
                            _createElementVNode("div", _hoisted_122, [
                              _hoisted_123,
                              ((_ctx.docApp.tip_request=='intern' && _ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_124, "create"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_125, [
                            _createTextVNode(_toDisplayString(_ctx.denOrgUnitFromOrg(Number(_ctx.docApp.id_org_destinatar_init))) + " ", 1),
                            ((_ctx.docApp.tip_request=='intern' && _ctx.docApp.status !== 'archived' && (_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y'))))
                              ? (_openBlock(), _createBlock(_component_q_popup_edit, {
                                  key: 0,
                                  modelValue: _ctx.den_org_destinatar_init,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.den_org_destinatar_init) = $event)),
                                  validate: val => val.length > 0,
                                  style: _normalizeStyle(_ctx.docApp.tip_request == 'intern' ? 'width:500px;' : '')
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("div", _hoisted_126, [
                                      _createElementVNode("div", _hoisted_127, [
                                        _createVNode(_component_q_select, {
                                          outlined: "",
                                          "lazy-rules": "",
                                          "model-value": _ctx.den_org_destinatar_init,
                                          "use-input": "",
                                          "hide-selected": "",
                                          "fill-input": "",
                                          "input-debounce": "300",
                                          options: _ctx.optionsOrgUnitPopup,
                                          onFilter: _ctx.filterOrgUnit,
                                          onNewValue: _cache[21] || (_cache[21] = (value) => _ctx.setOrgUnitModel(value, 'id_org_destinatar_init')),
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = (value) => _ctx.setOrgUnitModel(value, 'id_org_destinatar_init')),
                                          "emit-value": "",
                                          clearable: "",
                                          style: {"max-height":"7vh","width":"500px"},
                                          dense: "",
                                          "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                                          rules: [ val => val && val.length > 0 || 'Completati departamentul destinatar'],
                                          "option-value": "id",
                                          "option-label": "organization_unit_descriere"
                                        }, null, 8, ["model-value", "options", "onFilter", "rules"])
                                      ]),
                                      _hoisted_128,
                                      _createElementVNode("div", _hoisted_129, [
                                        _createVNode(_component_q_btn, {
                                          label: "Salveaza",
                                          size: "sm",
                                          color: "primary",
                                          onClick: ($event: any) => (_ctx.onSaveDocumentOrgUnitDestinatar(scope))
                                        }, null, 8, ["onClick"]),
                                        _createVNode(_component_q_btn, {
                                          label: "Renunt",
                                          size: "sm",
                                          type: "reset",
                                          flat: "",
                                          onClick: ($event: any) => (_ctx.onCancelDocumentOrgUnitDestinatar(scope)),
                                          style: {"margin-left":"5px"}
                                        }, null, 8, ["onClick"])
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "validate", "style"]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _hoisted_130,
                      _createElementVNode("td", _hoisted_131, _toDisplayString(_ctx.docApp.nr_inreg) + " / " + _toDisplayString(_ctx.displayDataLong(_ctx.docApp.data_inreg)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_132,
                      _createElementVNode("td", _hoisted_133, _toDisplayString(_ctx.denStare(_ctx.docApp.status)), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_134, [
                        _createElementVNode("div", _hoisted_135, [
                          _hoisted_136,
                          ((_ctx.docApp.status !== 'archived' && ((_ctx.user.is_admin=='y' || (_ctx.withFinalizeButton=='yes' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval') && _ctx.docApp.finalizat_de_inregistrat !== 'y' && _ctx.docApp.appid_referinta == null)))))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_137, "create"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_138, [
                        _createElementVNode("div", _hoisted_139, [
                          (_ctx.docApp.appid_referinta != null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.docApp.status !== 'archived' ? 'mousechange' : ''),
                                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.openReferenceAppIdDoc && _ctx.openReferenceAppIdDoc(...args)))
                                }, _toDisplayString(_ctx.docApp.ref_nr_doc) + " / " + _toDisplayString(_ctx.displayDataLong(_ctx.docApp.ref_data_doc)), 3)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_141, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.docApp.status !== 'archived' ? 'mousechange' : ''),
                                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.openDialogDocumentReference && _ctx.openDialogDocumentReference(...args)))
                                }, _toDisplayString(_ctx.docApp.ref_nr_doc) + " / " + _toDisplayString(_ctx.displayDataLong(_ctx.docApp.ref_data_doc)), 3)
                              ])),
                          (_ctx.user.is_admin=='y')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                _createElementVNode("span", {
                                  class: _normalizeClass([_ctx.docApp.status !== 'archived' ? 'mousechange' : '', "material-icons"]),
                                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.openDialogDocumentReference && _ctx.openDialogDocumentReference(...args))),
                                  style: {"margin-left":"auto","color":"red"}
                                }, "create", 2)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_q_dialog, {
                          modelValue: _ctx.visibleDialogEditReferintaExtern,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.visibleDialogEditReferintaExtern) = $event)),
                          persistent: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_card, { style: {"min-width":"95vh","max-width":"95vh"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_bar, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_icon, { name: "add_box" }),
                                    _hoisted_143,
                                    _createVNode(_component_q_space),
                                    _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                                      dense: "",
                                      flat: "",
                                      icon: "close"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Close")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })), [
                                      [_directive_close_popup]
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_card_section, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_144, [
                                      _createVNode(_component_q_form, { ref: "myForm" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_145, [
                                            _hoisted_146,
                                            _createVNode(_component_q_select, {
                                              outlined: "",
                                              modelValue: _ctx.ref_id_registru,
                                              "onUpdate:modelValue": [
                                                _cache[27] || (_cache[27] = ($event: any) => ((_ctx.ref_id_registru) = $event)),
                                                _ctx.onChangeValueRegistre
                                              ],
                                              options: _ctx.optionsRegistre,
                                              "option-value": "appid",
                                              "option-label": "den_registru_lang_1",
                                              "emit-value": "",
                                              "map-options": "",
                                              "lazy-rules": "",
                                              dense: "",
                                              style: {"min-width":"410px","max-width":"410px"},
                                              "content-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', maxHeight: '6vh' },
                                              "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' }
                                            }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
                                          ]),
                                          _createElementVNode("div", _hoisted_147, [
                                            _hoisted_148,
                                            (_ctx.ref_id_registru == null)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                                  _createVNode(_component_q_input, {
                                                    outlined: "",
                                                    modelValue: _ctx.ref_nr_doc,
                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.ref_nr_doc) = $event)),
                                                    "lazy-rules": "",
                                                    dense: "",
                                                    style: {"max-height":"7vh","max-width":"220px"},
                                                    "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
                                                    rules: [ val => val && val.length > 0 || 'Completati numar de referinta']
                                                  }, null, 8, ["modelValue", "rules"])
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                                  _createVNode(_component_q_select, {
                                                    outlined: "",
                                                    modelValue: _ctx.ref_nr_doc,
                                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.ref_nr_doc) = $event)),
                                                    options: _ctx.optionsNumarDocumenteReferinta,
                                                    "emit-value": "",
                                                    "map-options": "",
                                                    "lazy-rules": "",
                                                    "use-input": "",
                                                    "input-debounce": "300",
                                                    style: {"max-height":"7vh","max-width":"220px"},
                                                    dense: "",
                                                    clearable: "",
                                                    onInputValue: _cache[30] || (_cache[30] = (val) => _ctx.getNumarDocumentReferinta(val)),
                                                    "input-style": { fontFamily: 'Nunito Sans', fontWeight: 'bolder', color: 'black' },
                                                    rules: [ val => val && val > 0 || 'Completati numar de referinta']
                                                  }, {
                                                    "no-option": _withCtx(() => [
                                                      _createVNode(_component_q_item, null, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(" No results ")
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    option: _withCtx((scope) => [
                                                      _createVNode(_component_q_item, _mergeProps(scope.itemProps, {
                                                        onClick: ($event: any) => (_ctx.onValueChangeNumarDocumenteReferinta(scope.opt))
                                                      }), {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_q_item_section, null, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_q_item_label, null, {
                                                                default: _withCtx(() => [
                                                                  _createElementVNode("div", _hoisted_151, [
                                                                    _createElementVNode("div", _hoisted_152, _toDisplayString(scope.opt.id_doc), 1),
                                                                    _createElementVNode("div", _hoisted_153, _toDisplayString(scope.opt.data_doc), 1),
                                                                    _createElementVNode("div", _hoisted_154, _toDisplayString(scope.opt.den_registru), 1)
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_155, [
                                                                    _createElementVNode("div", _hoisted_156, _toDisplayString(scope.opt.den_tip_document), 1)
                                                                  ])
                                                                ]),
                                                                _: 2
                                                              }, 1024)
                                                            ]),
                                                            _: 2
                                                          }, 1024)
                                                        ]),
                                                        _: 2
                                                      }, 1040, ["onClick"])
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue", "options", "rules"])
                                                ]))
                                          ]),
                                          _createElementVNode("div", _hoisted_157, [
                                            _hoisted_158,
                                            _createVNode(_component_q_input, {
                                              class: "col-8",
                                              outlined: "",
                                              modelValue: _ctx.ref_data_doc,
                                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.ref_data_doc) = $event)),
                                              dense: "",
                                              mask: "##.##.####",
                                              style: {"max-height":"7vh","margin-bottom":"10px","max-width":"150px"},
                                              "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
                                              rules: [(val) => (val && val.length > 0) || 'Completati data referinta!']
                                            }, {
                                              append: _withCtx(() => [
                                                _createVNode(_component_q_icon, {
                                                  name: "event",
                                                  class: "cursor-pointer"
                                                })
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_popup_proxy, {
                                                  ref: "qDateProxy",
                                                  "transition-show": "scale",
                                                  "transition-hide": "scale"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_date, {
                                                      minimal: "",
                                                      modelValue: _ctx.ref_data_doc,
                                                      "onUpdate:modelValue": [
                                                        _cache[31] || (_cache[31] = ($event: any) => ((_ctx.ref_data_doc) = $event)),
                                                        _cache[32] || (_cache[32] = ($event: any) => ((_ctx.$refs['qDateProxy'] as any).hide()))
                                                      ],
                                                      mask: "DD.MM.YYYY",
                                                      locale: _ctx.myLocale
                                                    }, null, 8, ["modelValue", "locale"])
                                                  ]),
                                                  _: 1
                                                }, 512)
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "rules"])
                                          ])
                                        ]),
                                        _: 1
                                      }, 512),
                                      _hoisted_159,
                                      _createElementVNode("div", _hoisted_160, [
                                        _createVNode(_component_q_btn, {
                                          label: "Salveaza",
                                          size: "sm",
                                          type: "submit",
                                          color: "primary",
                                          onClick: _ctx.onSaveDocumentReference
                                        }, null, 8, ["onClick"]),
                                        _createVNode(_component_q_btn, {
                                          label: "Renunt",
                                          size: "sm",
                                          type: "reset",
                                          flat: "",
                                          onClick: _ctx.onCancelDocumentReference,
                                          style: {"margin-left":"5px"}
                                        }, null, 8, ["onClick"])
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_161, [
                        _createElementVNode("div", _hoisted_162, [
                          _hoisted_163,
                          ((_ctx.docApp.status !== 'archived' && ((_ctx.user.is_admin=='y' || (_ctx.docApp.este_repartizat=='y' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval'))) && _ctx.repartizari.length > 0)))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "material-icons cursor-pointer",
                                style: {"text-align":"flex-end","margin-left":"auto","color":"red","font-size":"1.3rem"},
                                onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.askIfDeleteRepartizare && _ctx.askIfDeleteRepartizare(...args)))
                              }, "delete_forever"))
                            : _createCommentVNode("", true),
                          ((_ctx.user.is_admin=='y' || (_ctx.docApp.este_repartizat=='y' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval'))))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "material-icons cursor-pointer",
                                style: _normalizeStyle(_ctx.repartizari.length == 0 ? 'text-align: flex-end;margin-left: auto; font-size: 1.2rem;' : 'margin-left: 5px; font-size: 1.2rem;'),
                                onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.openHistoryDialog && _ctx.openHistoryDialog(...args)))
                              }, "history", 4))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.docApp.data_repartizare && _ctx.docApp.data_repartizare.length>0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_164, "in " + _toDisplayString(_ctx.displayDataLong(_ctx.docApp.data_repartizare)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_165, [
                        (_ctx.loadingRepartizari && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval'))
                          ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                              key: 0,
                              query: "",
                              "track-color": "orange",
                              color: "purple",
                              class: "q-mt-sm"
                            }))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              style: {"display":"flex","align-items":"center","flex-wrap":"wrap"},
                              class: _normalizeClass({ 'lista_departamente_de_repartizat-mobile': _ctx.$q.platform.is.mobile, 'lista_departamente_de_repartizat-desktop': _ctx.$q.platform.is.desktop })
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repartizari.filter((item) => item.appid_org_destinatar != null), (repartizare, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "departament_repartizat",
                                  key: index
                                }, [
                                  _createElementVNode("div", null, [
                                    _createTextVNode(_toDisplayString(repartizare.den_org_destinatar) + " ", 1),
                                    ((_ctx.docApp.status !== 'archived' && ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_deleteallocation=='y') && (_ctx.docApp.este_repartizat=='y' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval')))))
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "material-icons cursor-pointer",
                                          style: {"margin-left":"auto","color":"red","font-size":"1.3rem"},
                                          onClick: ($event: any) => (_ctx.askIfDeleteRepartizareOrgUnitUtilizator(repartizare, true))
                                        }, "delete_forever", 8, _hoisted_166))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repartizari.filter((item) => item.appid_user_destinatar != null), (repartizare, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "departament_repartizat",
                                  key: index
                                }, [
                                  _createElementVNode("div", null, [
                                    _createTextVNode(_toDisplayString(repartizare.nume_prenume_user_destinatar) + " ", 1),
                                    ((_ctx.docApp.status !== 'archived' && ((_ctx.user.is_admin=='y' || _ctx.user.auth_for_deleteallocation=='y') && (_ctx.docApp.este_repartizat=='y' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval')))))
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "material-icons cursor-pointer",
                                          style: {"margin-left":"auto","color":"red","font-size":"1.3rem"},
                                          onClick: ($event: any) => (_ctx.askIfDeleteRepartizareOrgUnitUtilizator(repartizare, false))
                                        }, "delete_forever", 8, _hoisted_167))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ], 2))
                      ])
                    ]),
                    ((_ctx.docApp.tip_request=='intrare' || _ctx.docApp.tip_request=='iesire') && ['APP_DEV', 'APP_CV', 'APP_CJCV', 'APP_HR'].includes(_ctx.APP_NAME))
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_168, [
                          _hoisted_169,
                          _createElementVNode("td", _hoisted_170, _toDisplayString(_ctx.docApp.sursa), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ((Number(_ctx.docApp.flag) & 1) != 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_171, [
                          _hoisted_172,
                          _createElementVNode("td", _hoisted_173, _toDisplayString(_ctx.denPersoanaUtilizatorFromMarca(Number(_ctx.docApp.userid_cancellation))), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ((Number(_ctx.docApp.flag) & 1) != 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_174, [
                          _hoisted_175,
                          _createElementVNode("td", _hoisted_176, _toDisplayString(_ctx.displayDataLong(_ctx.docApp.data_cancellation)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ((Number(_ctx.docApp.flag) & 1) != 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_177, [
                          _hoisted_178,
                          _createElementVNode("td", _hoisted_179, _toDisplayString(_ctx.docApp.description_cancellation), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.docApp.status === 'archived' && _ctx.documentArhiva != null)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_180, [
                          _hoisted_181,
                          _createElementVNode("td", _hoisted_182, " Data " + _toDisplayString(_ctx.documentArhiva.predat_data) + " de " + _toDisplayString(_ctx.documentArhiva.predat_user_name) + ", " + _toDisplayString(_ctx.documentArhiva.descriere_biblioraft) + ", " + _toDisplayString(_ctx.documentArhiva.descriere_raft) + ", " + _toDisplayString(_ctx.documentArhiva.descriere_camera) + ", " + _toDisplayString(_ctx.documentArhiva.descriere_cladire), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_183, [
                _createElementVNode("div", _hoisted_184, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_185, [
                      _hoisted_186,
                      ((_ctx.docApp.status !== 'archived' && (_ctx.user.auth_for_upload_scan=='y' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval'))))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                            _createVNode(_component_q_btn, {
                              flat: "",
                              color: "primary",
                              icon: "add_box",
                              "no-caps": "",
                              onClick: _ctx.openFormUploadFile
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, {
                                  "transition-show": "rotate",
                                  "transition-hide": "rotate"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Incarca document nou ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_188, "Nimic atasat", 512), [
                      [_vShow, _ctx.docApp.scans != null && _ctx.docApp.scans.length==0 && !_ctx.uploadingFileToServer]
                    ]),
                    _withDirectives(_createElementVNode("div", null, "Pentru a finaliza inregistrarea este necesara incarcarea fisierului cu documentul scanat.", 512), [
                      [_vShow, (_ctx.docApp.status !== 'archived' && (_ctx.docApp.scans != null && _ctx.docApp.scans.length==0))]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_189, [
                  (_ctx.uploadingFileToServer)
                    ? (_openBlock(), _createBlock(_component_q_spinner, {
                        key: 0,
                        color: "primary",
                        size: "3em",
                        thickness: 10
                      }))
                    : (_openBlock(), _createElementBlock("table", _hoisted_190, [
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docApp.scans, (scan) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: scan.appid
                            }, [
                              ((_ctx.docApp.status !== 'archived' && ((_ctx.user.auth_for_deletedocument=='y' || _ctx.user.is_admin=='y'))))
                                ? (_openBlock(), _createElementBlock("td", _hoisted_191, [
                                    ((_ctx.user.auth_for_deletedocument=='y' || _ctx.user.is_admin=='y' || !_ctx.isRepartizat) && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval'))
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "material-icons cursor-pointer",
                                          style: {"color":"red","font-size":"1.3rem"},
                                          onClick: ($event: any) => (_ctx.askIfRemoveScan(scan))
                                        }, "delete_forever", 8, _hoisted_192))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("td", null, _toDisplayString(scan.file_ext), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan.file_size)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_193, _toDisplayString(scan.description), 1),
                                _createElementVNode("div", _hoisted_194, _toDisplayString(scan.description), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createVNode(_component_q_btn, {
                                  round: "",
                                  color: "black",
                                  icon: "cloud_download",
                                  size: "xs"
                                }),
                                _createVNode(_component_q_menu, {
                                  fit: "",
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DialogOpenScan, {
                                      appid: scan.appid,
                                      type_scan: "Document"
                                    }, null, 8, ["appid"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              (scan.is_signed == 'y')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_195, [
                                    _createVNode(_component_q_icon, {
                                      round: "",
                                      color: "black",
                                      name: "draw",
                                      size: "sm"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, {
                                          anchor: "top middle",
                                          self: "bottom middle",
                                          offset: [10, 10],
                                          "transition-show": "rotate",
                                          "transition-hide": "rotate"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Acest document contine semnatura digitala ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              (scan.is_stamped == 'y')
                                ? (_openBlock(), _createElementBlock("td", _hoisted_196, [
                                    _createVNode(_component_q_icon, {
                                      round: "",
                                      color: "black",
                                      name: "approval",
                                      size: "sm"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, {
                                          anchor: "top middle",
                                          self: "bottom middle",
                                          offset: [10, 10],
                                          "transition-show": "rotate",
                                          "transition-hide": "rotate"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(" Acest document a fost stampilat ")
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])),
                  (_ctx.docApp.status !== 'archived')
                    ? (_openBlock(), _createBlock(_component_q_file, {
                        key: 2,
                        "bottom-slots": "",
                        display: "none",
                        modelValue: _ctx.filesSelectedForUpload,
                        "onUpdate:modelValue": [
                          _cache[37] || (_cache[37] = ($event: any) => ((_ctx.filesSelectedForUpload) = $event)),
                          _ctx.myUploadMultipleFiles
                        ],
                        borderless: "",
                        counter: "",
                        multiple: "",
                        accept: ".pdf",
                        style: {"display":"flex"},
                        outlined: "",
                        "bg-color": "white",
                        "lazy-rules": "",
                        onClick: [
                          _cache[38] || (_cache[38] = _withModifiers(() => {}, ["stop","prevent"])),
                          _ctx.openFormUploadFile
                        ]
                      }, {
                        file: _withCtx(({ index, file }) => [
                          (index == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                _createElementVNode("table", _hoisted_198, [
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filesSelectedForUpload, (scan) => {
                                      return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", null, _toDisplayString(scan.name.split('.').pop()), 1),
                                        _createElementVNode("td", null, _toDisplayString(_ctx.humanReadableBytes(scan.size)), 1),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_199, _toDisplayString(scan.name), 1),
                                          _createElementVNode("div", _hoisted_200, _toDisplayString(scan.name), 1)
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createVNode(_component_q_spinner, {
                                            color: "primary",
                                            size: "1em"
                                          })
                                        ])
                                      ]))
                                    }), 256))
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_201, [
                            _createVNode(_component_q_icon, {
                              name: "cloud_upload",
                              size: "60px",
                              style: {"justify-self":"center"}
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onClick", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          (_ctx.withFinalizeButton=='yes' && !_ctx.isFinalizat && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                _withDirectives(_createVNode(_component_q_btn, {
                  size: "sm",
                  color: "primary",
                  "text-color": "white",
                  "icon-right": "bookmark_border",
                  label: "Finalizeaza inregistrarea!",
                  "no-caps": "",
                  onClick: _ctx.finalizeazaInregistrareDocument
                }, null, 8, ["onClick"]), [
                  [_vShow, (_ctx.docApp.scans?.length as number) > 0]
                ])
              ]))
            : _createCommentVNode("", true),
          (!['init', 'pending'].includes(_ctx.docApp.status))
            ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                _createVNode(_component_TaskList, {
                  appid: _ctx.appid,
                  task: _ctx.task,
                  onState: _ctx.onState,
                  isSuccess: _ctx.isSuccess
                }, null, 8, ["appid", "task", "onState", "isSuccess"])
              ]))
            : _createCommentVNode("", true)
        ])),
    ((_ctx.docApp.status !== 'archived' && ((_ctx.withRepartizareButton=='yes' || (_ctx.docApp.finalizat_de_inregistrat=='y')) && !_ctx.isRepartizat && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval'))))
      ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
          _createElementVNode("div", _hoisted_205, [
            _createElementVNode("div", null, [
              _withDirectives(_createVNode(_component_q_btn, {
                size: "sm",
                outline: "",
                color: "primary",
                label: "Repartizeaza la OrgUnit",
                icon: "add",
                onClick: _ctx.openFormAddOrgUnitRepartizare
              }, null, 8, ["onClick"]), [
                [_vShow, (!_ctx.nuSeRepartizeaza) && (_ctx.user.is_admin=='y' || _ctx.user.auth_todo_repartizare=='y')]
              ])
            ]),
            _createElementVNode("div", _hoisted_206, [
              _withDirectives(_createVNode(_component_q_btn, {
                size: "sm",
                outline: "",
                color: "primary",
                label: "Repartizeaza la Utilizator",
                icon: "add",
                onClick: _ctx.openFormAddUtilizatorRepartizare
              }, null, 8, ["onClick"]), [
                [_vShow, (!_ctx.nuSeRepartizeaza) && (_ctx.user.is_admin=='y' || _ctx.user.auth_todo_repartizare=='y')]
              ])
            ])
          ]),
          _withDirectives(_createVNode(_component_q_checkbox, {
            "keep-color": "",
            modelValue: _ctx.nuSeRepartizeaza,
            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.nuSeRepartizeaza) = $event)),
            label: "Nu se repartizeaza",
            color: "orange",
            onClick: _ctx.onChangeNuSeRepartizeaza
          }, null, 8, ["modelValue", "onClick"]), [
            [_vShow, _ctx.repartizari.length == 0]
          ]),
          _hoisted_207,
          _createElementVNode("div", {
            style: {"display":"flex","align-items":"center","flex-wrap":"wrap"},
            class: _normalizeClass({ 'lista_departamente_de_repartizat-mobile': _ctx.$q.platform.is.mobile, 'lista_departamente_de_repartizat-desktop': _ctx.$q.platform.is.desktop })
          }, [
            _createElementVNode("div", _hoisted_208, [
              _createElementVNode("div", _hoisted_209, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaOrgUnitPentruRepartizare, (orgUnit, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "departament_repartizat",
                    key: index
                  }, [
                    _createElementVNode("div", null, _toDisplayString(orgUnit.organization_unit_descriere) + " - " + _toDisplayString(orgUnit.tip_org_unit_id), 1),
                    _createElementVNode("span", {
                      class: "material-icons cursor-pointer",
                      onClick: ($event: any) => (_ctx.removeOrgUnitRepartizare(index)),
                      style: {"color":"red","font-weight":"bold","position":"relative","top":"-5px","right":"-5px"}
                    }, [
                      _createVNode(_component_q_tooltip, {
                        "transition-show": "rotate",
                        "transition-hide": "rotate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Sterge OrgUnit din repartizare ")
                        ]),
                        _: 1
                      }),
                      _createTextVNode("close")
                    ], 8, _hoisted_210)
                  ]))
                }), 128)),
                _withDirectives(_createVNode(_component_q_linear_progress, {
                  query: "",
                  "track-color": "orange",
                  color: "purple",
                  class: "q-mt-sm"
                }, null, 512), [
                  [_vShow, _ctx.showVisualEffectAddingOrgUnit]
                ])
              ]),
              _createElementVNode("div", _hoisted_211, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listaUtilizatorPentruRepartizare, (utilizator, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "departament_repartizat",
                    key: index
                  }, [
                    _createElementVNode("div", null, _toDisplayString(utilizator.marca) + " - " + _toDisplayString(utilizator.last_name) + " " + _toDisplayString(utilizator.first_name), 1),
                    _createElementVNode("span", {
                      class: "material-icons cursor-pointer",
                      onClick: ($event: any) => (_ctx.removeUtilizatorRepartizare(index)),
                      style: {"color":"red","font-weight":"bold","position":"relative","top":"-5px","right":"-5px"}
                    }, [
                      _createVNode(_component_q_tooltip, {
                        "transition-show": "rotate",
                        "transition-hide": "rotate"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Sterge Utilizator din repartizare ")
                        ]),
                        _: 1
                      }),
                      _createTextVNode("close")
                    ], 8, _hoisted_212)
                  ]))
                }), 128)),
                _withDirectives(_createVNode(_component_q_linear_progress, {
                  query: "",
                  "track-color": "orange",
                  color: "purple",
                  class: "q-mt-sm"
                }, null, 512), [
                  [_vShow, _ctx.showVisualEffectAddingUtilizator]
                ])
              ])
            ])
          ], 2),
          ((_ctx.listaOrgUnitPentruRepartizare.length > 0 || _ctx.listaUtilizatorPentruRepartizare.length > 0) && !_ctx.isRepartizat)
            ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                _withDirectives(_createVNode(_component_q_btn, {
                  size: "sm",
                  color: "primary",
                  "text-color": "white",
                  "icon-right": "device_hub",
                  label: "Repartizeaza documentul!",
                  "no-caps": "",
                  onClick: _ctx.repartizeazaDocument
                }, null, 8, ["onClick"]), [
                  [_vShow, (_ctx.user.is_admin=='y' || _ctx.user.auth_todo_repartizare=='y')]
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_214
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_215, [
          _withDirectives(_createVNode(_component_q_checkbox, {
            "keep-color": "",
            modelValue: _ctx.nuSeRepartizeaza,
            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.nuSeRepartizeaza) = $event)),
            label: "Nu se repartizeaza",
            disable: _ctx.user.is_admin!='y',
            color: "orange",
            onClick: _ctx.onChangeNuSeRepartizeaza
          }, null, 8, ["modelValue", "disable", "onClick"]), [
            [_vShow, (_ctx.docApp.status !== 'archived' && (_ctx.repartizari.length == 0 && _ctx.docApp.finalizat_de_inregistrat=='y' && (_ctx.docApp.status === 'init' || _ctx.docApp.status === 'pending' || _ctx.docApp.status === 'inapproval')))]
          ])
        ])),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogUploadFile,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.dialogUploadFile) = $event)),
      position: "top"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"350px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_linear_progress, {
              value: 0.6,
              color: "pink"
            }),
            _createVNode(_component_q_card_section, { class: "column no-wrap" }, {
              default: _withCtx(() => [
                _hoisted_216,
                _createElementVNode("div", _hoisted_217, [
                  _createVNode(_component_q_input, {
                    counter: "",
                    outlined: "",
                    modelValue: _ctx.uploadScanTitle,
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.uploadScanTitle) = $event)),
                    label: "Titlu document (minim 4 caractere)",
                    dense: "",
                    maxlength: "200"
                  }, null, 8, ["modelValue"])
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "file",
                  name: "fileToUpload",
                  id: "fileToUpload",
                  ref: "myFileToUpload",
                  onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.prepareForUpload($event))),
                  style: {"margin-bottom":"10px"}
                }, null, 544), [
                  [_vShow, _ctx.uploadScanTitle.length>3]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  disable: !(_ctx.uploadScanTitle.length>3),
                  icon: "cloud_upload",
                  color: "white",
                  "text-color": "black",
                  label: "Salveaza pe server",
                  onClick: _ctx.myUploadFile,
                  loading: _ctx.uploadingFileToServer,
                  style: {"margin-bottom":"5px"}
                }, null, 8, ["disable", "onClick", "loading"]), [
                  [_vShow, _ctx.checkIfFileIsSelected]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogAddOrgUnitRepartizare,
      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.dialogAddOrgUnitRepartizare) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"min-width":"70vw"},
          class: _normalizeClass({ 'partial80_height': _ctx.$q.platform.is.mobile, 'partial60_height': _ctx.$q.platform.is.desktop })
        }, {
          default: _withCtx(() => [
            (_ctx.loadingDataOrgUnit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                  _createVNode(_component_q_circular_progress, {
                    size: "xl",
                    color: "primary",
                    class: "q-ma-md",
                    indeterminate: ""
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_219, [
                  _hoisted_220,
                  _createElementVNode("div", _hoisted_221, [
                    _createVNode(_component_q_table, {
                      dense: "",
                      "rows-per-page-options": [0],
                      rows: _ctx.tableDataNomOrgUnit,
                      columns: _ctx.columnsOrgUnit,
                      "visible-columns": _ctx.visibleColumnsOrgUnit,
                      filter: _ctx.filterDataOrgUnit,
                      loading: _ctx.loadingDataOrgUnit,
                      "row-key": "id",
                      pagination: _ctx.myPagination,
                      style: {"height":"470px"},
                      "virtual-scroll-item-size": 48
                    }, {
                      top: _withCtx(() => [
                        _createElementVNode("div", _hoisted_222, [
                          _createElementVNode("div", _hoisted_223, [
                            _createVNode(_component_q_space),
                            _createVNode(_component_q_input, {
                              dense: "",
                              debounce: "300",
                              color: "primary",
                              modelValue: _ctx.filterDataOrgUnit,
                              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.filterDataOrgUnit) = $event))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_q_icon, { name: "search" })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      header: _withCtx((props) => [
                        _createVNode(_component_q_tr, { props: props }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                              return (_openBlock(), _createBlock(_component_q_th, {
                                key: col.name,
                                props: props
                              }, {
                                default: _withCtx(() => [
                                  (col.name == 'status')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_224, [
                                        _createVNode(_component_q_checkbox, {
                                          color: "primary",
                                          modelValue: _ctx.selectedAllfilterOrgUnit,
                                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.selectedAllfilterOrgUnit) = $event)),
                                          label: col.label,
                                          "left-label": "",
                                          onClick: _ctx.changeOrgUnitStatusAll
                                        }, null, 8, ["modelValue", "label", "onClick"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_225, _toDisplayString(col.label), 1))
                                ]),
                                _: 2
                              }, 1032, ["props"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      body: _withCtx((props) => [
                        _createVNode(_component_q_tr, { props: props }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_td, {
                              key: "organization_unit_descriere",
                              props: props,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"},
                              onClick: ($event: any) => (_ctx.selectOrgUnitFromOption(props.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.organization_unit_descriere), 1)
                              ]),
                              _: 2
                            }, 1032, ["props", "onClick"]),
                            _createVNode(_component_q_td, {
                              key: "tip_org_unit_id",
                              props: props,
                              onClick: ($event: any) => (_ctx.selectOrgUnitFromOption(props.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.tip_org_unit_id), 1)
                              ]),
                              _: 2
                            }, 1032, ["props", "onClick"]),
                            _createVNode(_component_q_td, {
                              key: "status",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_checkbox, {
                                  color: "primary",
                                  modelValue: props.row.status,
                                  "onUpdate:modelValue": ($event: any) => ((props.row.status) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["props"])
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      _: 1
                    }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"]),
                    _hoisted_226,
                    _createElementVNode("div", _hoisted_227, [
                      _createElementVNode("div", _hoisted_228, [
                        _createVNode(_component_q_btn, {
                          label: "Salveaza",
                          size: "sm",
                          type: "submit",
                          color: "primary",
                          onClick: _ctx.onSaveOrgUnitSelected
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_q_btn, {
                          label: "Renunt",
                          size: "sm",
                          type: "reset",
                          flat: "",
                          onClick: _ctx.onCancelOrgUnitSelected,
                          style: {"margin-left":"5px"}
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ])
                ]))
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogAddUtilizatorRepartizare,
      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.dialogAddUtilizatorRepartizare) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"min-width":"70vw"},
          class: _normalizeClass({ 'partial80_height': _ctx.$q.platform.is.mobile, 'partial60_height': _ctx.$q.platform.is.desktop })
        }, {
          default: _withCtx(() => [
            (_ctx.loadingDataUtilizator)
              ? (_openBlock(), _createElementBlock("div", _hoisted_229, [
                  _createVNode(_component_q_circular_progress, {
                    size: "xl",
                    color: "primary",
                    class: "q-ma-md",
                    indeterminate: ""
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_230, [
                  _hoisted_231,
                  _createElementVNode("div", _hoisted_232, [
                    _createVNode(_component_q_table, {
                      dense: "",
                      "rows-per-page-options": [0],
                      rows: _ctx.tableDataNomUtilizator,
                      columns: _ctx.columnsUtilizator,
                      "visible-columns": _ctx.visibleColumnsUtilizator,
                      filter: _ctx.filterDataUtilizator,
                      loading: _ctx.loadingDataUtilizator,
                      "row-key": "marca",
                      pagination: _ctx.myPagination,
                      style: {"height":"470px"},
                      "virtual-scroll-item-size": 48
                    }, {
                      top: _withCtx(() => [
                        _createElementVNode("div", _hoisted_233, [
                          _createElementVNode("div", _hoisted_234, [
                            _createVNode(_component_q_space),
                            _createVNode(_component_q_input, {
                              dense: "",
                              debounce: "300",
                              color: "primary",
                              modelValue: _ctx.filterDataUtilizator,
                              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.filterDataUtilizator) = $event))
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_q_icon, { name: "search" })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_235, [
                          _hoisted_236,
                          _createVNode(_component_q_space),
                          _createVNode(_component_q_toggle, {
                            dense: "",
                            modelValue: _ctx.celeInactivefilterUtilizator,
                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.celeInactivefilterUtilizator) = $event)),
                            "checked-icon": "lock",
                            debounce: "300",
                            color: "primary",
                            "unchecked-icon": "lock_open",
                            "false-value": "Nu",
                            "true-value": "Da",
                            onClick: _ctx.changeUtilizatorStatusFilter
                          }, null, 8, ["modelValue", "onClick"])
                        ])
                      ]),
                      header: _withCtx((props) => [
                        _createVNode(_component_q_tr, { props: props }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                              return (_openBlock(), _createBlock(_component_q_th, {
                                key: col.name,
                                props: props
                              }, {
                                default: _withCtx(() => [
                                  (col.name == 'status')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_237, [
                                        _createVNode(_component_q_checkbox, {
                                          color: "primary",
                                          modelValue: _ctx.selectedAllfilterUtilizator,
                                          "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.selectedAllfilterUtilizator) = $event)),
                                          label: col.label,
                                          "left-label": "",
                                          onClick: _ctx.changeUtilizatorStatusAll
                                        }, null, 8, ["modelValue", "label", "onClick"])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_238, _toDisplayString(col.label), 1))
                                ]),
                                _: 2
                              }, 1032, ["props"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["props"])
                      ]),
                      body: _withCtx((props) => [
                        _createVNode(_component_q_tr, {
                          props: props,
                          style: _normalizeStyle(props.row.is_activ == 'n' ? 'background-color: #dddddd' : '')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_td, {
                              key: "marca",
                              props: props,
                              onClick: ($event: any) => (_ctx.selectUtilizatorFromOption(props.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.marca), 1)
                              ]),
                              _: 2
                            }, 1032, ["props", "onClick"]),
                            _createVNode(_component_q_td, {
                              key: "nume_prenume",
                              props: props,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"},
                              onClick: ($event: any) => (_ctx.selectUtilizatorFromOption(props.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.nume_prenume), 1)
                              ]),
                              _: 2
                            }, 1032, ["props", "onClick"]),
                            _createVNode(_component_q_td, {
                              key: "organization_unit_descriere",
                              props: props,
                              style: {"white-space":"pre-wrap","word-wrap":"break-word"},
                              onClick: ($event: any) => (_ctx.selectUtilizatorFromOption(props.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.organization_unit_descriere), 1)
                              ]),
                              _: 2
                            }, 1032, ["props", "onClick"]),
                            _createVNode(_component_q_td, {
                              key: "job_title",
                              props: props,
                              onClick: ($event: any) => (_ctx.selectUtilizatorFromOption(props.row))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.row.job_title), 1)
                              ]),
                              _: 2
                            }, 1032, ["props", "onClick"]),
                            _createVNode(_component_q_td, {
                              key: "status",
                              props: props
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_checkbox, {
                                  color: "primary",
                                  modelValue: props.row.status,
                                  "onUpdate:modelValue": ($event: any) => ((props.row.status) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["props"])
                          ]),
                          _: 2
                        }, 1032, ["props", "style"])
                      ]),
                      _: 1
                    }, 8, ["rows", "columns", "visible-columns", "filter", "loading", "pagination"]),
                    _hoisted_239,
                    _createElementVNode("div", _hoisted_240, [
                      _createElementVNode("div", _hoisted_241, [
                        _createVNode(_component_q_btn, {
                          label: "Salveaza",
                          size: "sm",
                          type: "submit",
                          color: "primary",
                          onClick: _ctx.onSaveUtilizatorSelected
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_q_btn, {
                          label: "Renunt",
                          size: "sm",
                          type: "reset",
                          flat: "",
                          onClick: _ctx.onCancelUtilizatorSelected,
                          style: {"margin-left":"5px"}
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ])
                ]))
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogHistoricRepartizare,
      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.dialogHistoricRepartizare) = $event)),
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"80vw","max-width":"85vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, { name: "add_box" }),
                _hoisted_242,
                _createVNode(_component_q_space),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_RepartizatHistoric, {
                  appid_doc: _ctx.docApp.appid,
                  id_registru: _ctx.docApp.id_registru,
                  foncancel: _ctx.closeHistoricRepartizare
                }, null, 8, ["appid_doc", "id_registru", "foncancel"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogMessage,
      "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.dialogMessage) = $event)),
      persistent: "",
      "transition-show": "slide-up",
      "transition-hide": "slide-down"
    }, {
      default: _withCtx(() => [
        (_ctx.messageProgress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_243, [
              _createVNode(_component_q_circular_progress, {
                size: "xl",
                color: "primary",
                class: "q-ma-md",
                indeterminate: ""
              })
            ]))
          : (_openBlock(), _createBlock(_component_q_card, {
              key: 1,
              style: {"min-width":"60vw","max-width":"75vw","max-height":"75vh","background-color":"#ececec"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "message" }),
                    _hoisted_244,
                    _createVNode(_component_q_space),
                    _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      dense: "",
                      flat: "",
                      icon: "close"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          "transition-show": "rotate",
                          "transition-hide": "rotate"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Close")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, { style: {"min-height":"58vh","max-height":"58vh"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_scroll_area, {
                      ref: "chatScroll",
                      style: {"height":"55vh"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_245, [
                          _createElementVNode("div", _hoisted_246, [
                            (_ctx.chatMessages.length == 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_247, _hoisted_249))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.chatMessages, (message, index) => {
                                  return (_openBlock(), _createBlock(_component_q_chat_message, {
                                    key: index,
                                    avatar: "data:image/png;base64,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",
                                    name: message.name,
                                    sent: message.sent,
                                    stamp: message.stamp,
                                    "bg-color": message.name !== 'Odocs' ? 'orange-2' : 'primary',
                                    "text-color": message.name !== 'Odocs' ? 'black' : 'white'
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_250, _toDisplayString(message.text), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["name", "sent", "stamp", "bg-color", "text-color"]))
                                }), 128))
                          ])
                        ])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_actions, { style: {"background-color":"#f9f9f9"} }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_251, [
                      _createElementVNode("div", _hoisted_252, [
                        _createVNode(_component_q_input, {
                          autofocus: "",
                          ref: "textInputMessage",
                          outlined: "",
                          style: {"width":"100%"},
                          type: "textarea",
                          "lazy-rules": "",
                          dense: "",
                          rows: "2",
                          maxlength: "500",
                          modelValue: _ctx.messageText,
                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.messageText) = $event)),
                          "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
                          disable: _ctx.messageProgress
                        }, null, 8, ["modelValue", "disable"])
                      ]),
                      _createElementVNode("div", _hoisted_253, [
                        _createVNode(_component_q_btn, {
                          flat: "",
                          outline: "",
                          dense: "",
                          "icon-right": "send",
                          color: "primary",
                          style: {"width":"100%"},
                          class: "q-ml-sm",
                          onClick: _ctx.onSendMessage,
                          disable: (!(_ctx.messageText.length > 0) || _ctx.messageProgress)
                        }, null, 8, ["onClick", "disable"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogCancellationDocument,
      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.dialogCancellationDocument) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"min-width":"350px"},
          class: "my-card"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_254
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_form, { ref: "myFormCancellationDocument" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_input, {
                      autofocus: "",
                      outlined: "",
                      style: {"max-height":"15vh"},
                      modelValue: _ctx.description_cancellation,
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.description_cancellation) = $event)),
                      type: "textarea",
                      "lazy-rules": "",
                      counter: "",
                      maxlength: "200",
                      rows: "3",
                      dense: "",
                      "input-style": { fontFamily: 'Nunito Sans',fontWeight: 'bolder', color: 'black' },
                      rules: [ val => val && val.length > 0 || 'Completati motivul!']
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, {
              align: "right",
              class: "text-primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  color: "deep-orange",
                  size: "sm",
                  label: "Anulare",
                  onClick: _ctx.onSendCancellationDocument,
                  type: "submit",
                  disable: (Number(_ctx.docApp.flag) & 1) == 0 && _ctx.description_cancellation?.length == 0
                }, null, 8, ["onClick", "disable"]),
                _withDirectives(_createVNode(_component_q_btn, {
                  label: "Abandonare",
                  size: "sm",
                  type: "reset"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.visibleDialogEditFormCertificateUrbanism,
      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.visibleDialogEditFormCertificateUrbanism) = $event)),
      persistent: "",
      "transition-show": "slide-left",
      "transition-hide": "slide-right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"65vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
              default: _withCtx(() => [
                _hoisted_255,
                _createVNode(_component_q_space),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close",
                  onClick: _ctx.renuntEditareForm
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "rotate",
                      "transition-hide": "rotate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_EditCertificateUrbanism, {
                  foncancel: _ctx.renuntEditareForm,
                  fonsave: _ctx.renuntEditareForm,
                  appid: (_ctx.appid_documentextended == null ? 0 : _ctx.appid_documentextended),
                  appid_document: _ctx.appid
                }, null, 8, ["foncancel", "fonsave", "appid", "appid_document"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showPreviewFileCertificateUrbanism,
      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.showPreviewFileCertificateUrbanism) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": "slide-up",
      "transition-hide": "slide-down"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                _createElementVNode("h5", null, _toDisplayString(_ctx.titleForPreviewForm), 1),
                _createVNode(_component_q_space),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "rotate",
                      "transition-hide": "rotate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_ctx.downloadingFile)
                  ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                      key: 0,
                      query: "",
                      "track-color": "orange",
                      color: "purple",
                      class: "q-mt-sm"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isPDFFileType)
                  ? (_openBlock(), _createElementBlock("iframe", _hoisted_256))
                  : (_openBlock(), _createElementBlock("img", _hoisted_257))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.visibleDialogEditFormServiciiDeTransport,
      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.visibleDialogEditFormServiciiDeTransport) = $event)),
      persistent: "",
      "transition-show": "slide-left",
      "transition-hide": "slide-right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"min-width":"60vw","max-width":"65vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, { style: {"height":"30px"} }, {
              default: _withCtx(() => [
                _hoisted_258,
                _createVNode(_component_q_space),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close",
                  onClick: _ctx.renuntEditareForm
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "rotate",
                      "transition-hide": "rotate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_EditServiciiDeTransport, {
                  foncancel: _ctx.renuntEditareForm,
                  fonsave: _ctx.renuntEditareForm,
                  appid: (_ctx.appid_documentextended == null ? 0 : _ctx.appid_documentextended),
                  appid_document: _ctx.appid
                }, null, 8, ["foncancel", "fonsave", "appid", "appid_document"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showPreviewFileServiciiDeTransport,
      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.showPreviewFileServiciiDeTransport) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": "slide-up",
      "transition-hide": "slide-down"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                _createElementVNode("h5", null, _toDisplayString(_ctx.titleForPreviewForm), 1),
                _createVNode(_component_q_space),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  dense: "",
                  flat: "",
                  icon: "close"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "rotate",
                      "transition-hide": "rotate"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_ctx.downloadingFile)
                  ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                      key: 0,
                      query: "",
                      "track-color": "orange",
                      color: "purple",
                      class: "q-mt-sm"
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isPDFFileType)
                  ? (_openBlock(), _createElementBlock("iframe", _hoisted_259))
                  : (_openBlock(), _createElementBlock("img", _hoisted_260))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}